import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../Translations';

interface Props {
  beta: boolean;
}

const Beta: React.FC<Props> = ({ beta }) => {
  return beta ? (
    <span className="ml-2 rounded-sm bg-amber-600 px-2 pt-1 pb-0.5 text-sm text-white">
      <T kind="Beta" />
    </span>
  ) : (
    <></>
  );
};

export default observer(Beta);
